let politeTimeout = null;
let assertiveTimeout = null;
const DEBOUNCE_MS = 300;
const CLEAR_DELAY_MS = 5000;

function ensureAlertRegion() {
    if(!$('#cart-alert-announcer').length) {
        $('body').append('<div id="cart-alert-announcer" role="alert" aria-live="assertive" aria-atomic="true" class="sr-only"></div>');
    }
}

/**
 * Announces a polite message to screen readers (does not interrupt).
 * Uses the existing #loading-announcer from the layout.
 * Debounces rapid successive calls so only the final message in a burst is spoken.
 */
export function announcePolite(message) {
    const $region = $('#loading-announcer');
    if(!$region.length) return;

    $region.text('');

    if(politeTimeout) {
        clearTimeout(politeTimeout);
    }

    politeTimeout = setTimeout(function () {
        $region.text(message);
        politeTimeout = null;

        // Clear after screen reader has time to read
        setTimeout(function() { $region.text(''); }, CLEAR_DELAY_MS);
    }, DEBOUNCE_MS);
}

/**
 * Announces an assertive message to screen readers (interrupts current speech).
 * Used for errors, warnings, and maximum limits.
 */
export function announceAssertive(message) {
    ensureAlertRegion();
    const $region = $('#cart-alert-announcer');

    $region.text('');

    if(assertiveTimeout) {
        clearTimeout(assertiveTimeout);
    }

    assertiveTimeout = setTimeout(function () {
        $region.text(message);
        assertiveTimeout = null;

        setTimeout(function() { $region.text(''); }, CLEAR_DELAY_MS);
    }, 100);
}

/**
 * Updates the header cart count and announces via the shared live region.
 * Silently updates #cart-status text (suppresses its aria-live to avoid
 * a duplicate announcement) and routes through announcePolite for a
 * single consistent announcement path.
 */
export function announceCartUpdate(itemCount) {
    const $region = $('#cart-status');
    const message = itemCount > 0
        ? itemCount + ' items in cart'
        : 'Empty cart';

    // Silently update #cart-status accessible text without triggering its aria-live
    if($region.length) {
        $region.attr('aria-live', 'off');
        $region.text(message);
        setTimeout(function() { $region.attr('aria-live', 'polite'); }, 200);
    }

    announcePolite(message);
}

/**
 * Announces that a product was added to cart with product name context.
 * Use this instead of announceCartUpdate when the product name is available.
 */
export function announceAddedToCart(productName, itemCount) {
    const $region = $('#cart-status');
    const statusText = itemCount > 0
        ? itemCount + ' items in cart'
        : 'Empty cart';

    // Silently update #cart-status accessible text
    if($region.length) {
        $region.attr('aria-live', 'off');
        $region.text(statusText);
        setTimeout(function() { $region.attr('aria-live', 'polite'); }, 200);
    }

    const message = productName
        ? productName + ' added to cart. Cart now contains ' + itemCount + ' items.'
        : itemCount + ' items in cart';
    announcePolite(message);
}

/**
 * Builds and announces a quantity update completion message.
 */
export function announceQuantityUpdated(productName, newQuantity, totalItems, newTotal) {
    const message = 'Quantity updated for ' + productName + '. New quantity: ' + newQuantity + '. Cart now contains ' + totalItems + ' items. New total: ' + newTotal + '.';
    announcePolite(message);
}

/**
 * Announces that a quantity update is in progress.
 */
export function announceQuantityUpdating(productName) {
    announcePolite('Updating quantity for ' + productName);
}

/**
 * Announces item removal completion.
 */
export function announceItemRemoved(productName, remainingItems, newTotal) {
    let message;
    if(remainingItems === 0) {
        message = productName + ' removed from cart. Your cart is now empty.';
    } else {
        message = productName + ' removed from cart. ' + remainingItems + ' items remaining. New total: ' + newTotal + '.';
    }
    announcePolite(message);
}

/**
 * Announces that item removal is in progress.
 */
export function announceItemRemoving(productName) {
    announcePolite('Removing ' + productName + ' from cart');
}

/**
 * Announces maximum quantity reached (assertive - interrupts).
 */
export function announceMaxQuantity(productName, maxQuantity) {
    announceAssertive('Maximum quantity reached for ' + productName + '. Maximum allowed is ' + maxQuantity + '.');
}

/**
 * Announces a cart error (assertive - interrupts).
 */
export function announceCartError(productName, errorMessage) {
    if(errorMessage) {
        announceAssertive(errorMessage);
    } else if(productName) {
        announceAssertive('Unable to update cart for ' + productName + '. Please try again.');
    } else {
        announceAssertive('Unable to update cart. Please check your connection and try again.');
    }
}

/**
 * Announces free shipping qualification.
 */
export function announceFreeShipping() {
    announcePolite('Congratulations! You now qualify for free shipping.');
}

/**
 * Announces below minimum order threshold (assertive - warning).
 */
export function announceBelowMinimum(minimumAmount, amountNeeded) {
    announceAssertive('Order total is below minimum of ' + minimumAmount + '. Add ' + amountNeeded + ' more to checkout.');
}
